export { default } from "./ContentManagementSystem";
